import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelDynamic as _vModelDynamic, withModifiers as _withModifiers, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "min-h-screen relative overflow-hidden" }
const _hoisted_2 = { class: "relative z-10 min-h-screen flex items-center justify-center p-4 sm:p-6 lg:p-8" }
const _hoisted_3 = { class: "w-full max-w-3xl" }
const _hoisted_4 = { class: "text-center mb-8" }
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 0,
  class: "mb-6 rounded-md bg-red-50 p-4"
}
const _hoisted_7 = { class: "flex" }
const _hoisted_8 = { class: "ml-3" }
const _hoisted_9 = { class: "text-sm text-red-700" }
const _hoisted_10 = { class: "relative" }
const _hoisted_11 = ["type"]
const _hoisted_12 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  class: "w-6 h-6"
}
const _hoisted_13 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  class: "w-6 h-6"
}
const _hoisted_14 = { class: "flex justify-center" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = { class: "text-center mt-8" }
const _hoisted_17 = { class: "text-xl text-zinc-700" }

import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import backgroundImage from '@/assets/staticbg.png'
import logoImage from '@/assets/main_logo.png'


export default /*@__PURE__*/_defineComponent({
  __name: 'AdminLoginView',
  setup(__props) {

const router = useRouter()
const authStore = useAuthStore()

// Form state
const email = ref('')
const password = ref('')
const loading = ref(false)
const error = ref('')
const showPassword = ref(false)

const handleAdminLogin = async () => {
  try {
    loading.value = true
    error.value = ''

    // Validate input
    if (!email.value || !password.value) {
      throw new Error('Please enter both email and password')
    }

    // Call admin login API
    await authStore.adminLogin({
      email: email.value,
      password: password.value
    })

    // Redirect handled by auth store

  } catch (err: any) {
    console.error('Admin login error:', err)

    if (err.response?.data?.message) {
      error.value = err.response.data.message
    } else if (err.message) {
      error.value = err.message
    } else {
      error.value = 'Admin login failed. Please try again.'
    }
  } finally {
    loading.value = false
  }
}

const goToCustomerLogin = () => {
  router.push('/brands')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[8] || (_cache[8] = _createElementVNode("div", { class: "absolute inset-0 bg-gray-200 bg-opacity-80" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("img", {
              src: _unref(logoImage),
              alt: "Admin Portal",
              class: "mx-auto w-96 object-contain"
            }, null, 8, _hoisted_5),
            _cache[3] || (_cache[3] = _createElementVNode("p", { class: "mt-8 mb-6 text-2xl font-medium text-zinc-700" }, " Sign In to Manage the System ", -1))
          ]),
          (error.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _cache[4] || (_cache[4] = _createElementVNode("div", { class: "flex-shrink-0" }, [
                    _createElementVNode("svg", {
                      class: "h-5 w-5 text-red-400",
                      xmlns: "http://www.w3.org/2000/svg",
                      viewBox: "0 0 20 20",
                      fill: "currentColor"
                    }, [
                      _createElementVNode("path", {
                        "fill-rule": "evenodd",
                        d: "M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z",
                        "clip-rule": "evenodd"
                      })
                    ])
                  ], -1)),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("p", _hoisted_9, _toDisplayString(error.value), 1)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("form", {
            onSubmit: _withModifiers(handleAdminLogin, ["prevent"]),
            class: "space-y-6 bg-white p-16 rounded-2xl"
          }, [
            _createElementVNode("div", null, [
              _withDirectives(_createElementVNode("input", {
                id: "email",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
                type: "email",
                placeholder: "Admin Email Address*",
                required: "",
                class: "w-full px-8 py-5 bg-transparent border-2 border-zinc-200 rounded-lg focus:outline-none placeholder-zinc-700 placeholder:text-lg text-zinc-700 focus:border-blue-600 transition-colors"
              }, null, 512), [
                [_vModelText, email.value]
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _withDirectives(_createElementVNode("input", {
                id: "password",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((password).value = $event)),
                type: showPassword.value ? 'text' : 'password',
                placeholder: "Password*",
                required: "",
                class: "w-full px-8 py-5 pr-14 bg-transparent border-2 border-zinc-200 rounded-lg focus:outline-none placeholder-zinc-700 placeholder:text-lg text-zinc-700 focus:border-blue-600 transition-colors"
              }, null, 8, _hoisted_11), [
                [_vModelDynamic, password.value]
              ]),
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (showPassword.value = !showPassword.value)),
                class: "absolute inset-y-0 right-0 pr-4 flex items-center text-zinc-500 hover:text-zinc-700 transition-colors"
              }, [
                (showPassword.value)
                  ? (_openBlock(), _createElementBlock("svg", _hoisted_12, _cache[5] || (_cache[5] = [
                      _createElementVNode("path", { d: "M3.53 2.47a.75.75 0 0 0-1.06 1.06l18 18a.75.75 0 1 0 1.06-1.06l-18-18ZM22.676 12.553a11.249 11.249 0 0 1-2.631 4.31l-3.099-3.099a5.25 5.25 0 0 0-6.71-6.71L7.759 4.577a11.217 11.217 0 0 1 4.242-.827c4.97 0 9.185 3.223 10.675 7.69.12.362.12.752 0 1.113Z" }, null, -1),
                      _createElementVNode("path", { d: "M15.75 12c0 .18-.013.357-.037.53l-4.244-4.243A3.75 3.75 0 0 1 15.75 12ZM12.53 15.713l-4.243-4.244a3.75 3.75 0 0 0 4.244 4.243Z" }, null, -1),
                      _createElementVNode("path", { d: "M6.75 12c0-.619.107-1.213.304-1.764l-3.1-3.1a11.25 11.25 0 0 0-2.63 4.31c-.12.362-.12.752 0 1.114 1.489 4.467 5.704 7.69 10.675 7.69 1.5 0 2.933-.294 4.242-.827l-2.477-2.477A5.25 5.25 0 0 1 6.75 12Z" }, null, -1)
                    ])))
                  : (_openBlock(), _createElementBlock("svg", _hoisted_13, _cache[6] || (_cache[6] = [
                      _createElementVNode("path", { d: "M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" }, null, -1),
                      _createElementVNode("path", {
                        "fill-rule": "evenodd",
                        d: "M1.323 11.447C2.811 6.976 7.028 3.75 12.001 3.75c4.97 0 9.185 3.223 10.675 7.69.12.362.12.752 0 1.113-1.487 4.471-5.705 7.697-10.677 7.697-4.97 0-9.186-3.223-10.675-7.69a1.762 1.762 0 0 1 0-1.113ZM17.25 12a5.25 5.25 0 1 1-10.5 0 5.25 5.25 0 0 1 10.5 0Z",
                        "clip-rule": "evenodd"
                      }, null, -1)
                    ])))
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("button", {
                type: "submit",
                disabled: loading.value,
                class: "px-16 py-3 font-medium text-xl rounded-full bg-blue-600 text-white hover:bg-blue-700 transition-colors disabled:opacity-70 disabled:cursor-not-allowed"
              }, _toDisplayString(loading.value ? 'Signing in...' : 'Sign In'), 9, _hoisted_15)
            ])
          ], 32),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("p", _hoisted_17, [
              _cache[7] || (_cache[7] = _createTextVNode(" Not an admin? ")),
              _createElementVNode("a", {
                href: "#",
                onClick: _withModifiers(goToCustomerLogin, ["prevent"]),
                class: "font-medium text-blue-600 hover:text-blue-700 hover:underline"
              }, " Customer Login ")
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})